export default __webpack_public_path__ + "static/media/dashboard_error_exclamation_circle.43a62d85.svg";